var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "140px",
    height: "22px",
    viewBox: "0 0 140 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EED76E82-37DB-4B8C-8019-ED59CE544F36@0.50x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "09.2----Profil-|-Vue-employ\\xE9-|-Dialog---Annuaire-chgt-compte",
    transform: "translate(-651.000000, -907.000000)",
    fill: "#4965FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog",
    transform: "translate(402.000000, 838.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logotypes",
    transform: "translate(145.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(104.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.91,13.803 L3.37,13.803 C1.66,13.803 0.28,12.422 0.28,10.719 C0.28,9.016 1.66,7.634 3.37,7.634 L4.91,7.634 C6.61,7.634 7.99,9.016 7.99,10.719 C7.99,12.422 6.61,13.803 4.91,13.803 Z M17.25,13.803 L15.7,13.803 C14,13.803 12.62,12.422 12.62,10.719 C12.62,9.016 14,7.634 15.7,7.634 L17.25,7.634 C18.95,7.634 20.33,9.016 20.33,10.719 C20.33,12.422 18.95,13.803 17.25,13.803 Z M29.58,13.803 L28.04,13.803 C26.34,13.803 24.96,12.422 24.96,10.719 C24.96,9.016 26.34,7.634 28.04,7.634 L29.58,7.634 C31.29,7.634 32.67,9.016 32.67,10.719 C32.67,12.422 31.29,13.803 29.58,13.803 Z M41.92,13.803 L40.38,13.803 C38.68,13.803 37.29,12.422 37.29,10.719 C37.29,9.016 38.68,7.634 40.38,7.634 L41.92,7.634 C43.62,7.634 45,9.016 45,10.719 C45,12.422 43.62,13.803 41.92,13.803 Z M54.26,13.803 L52.71,13.803 C51.01,13.803 49.63,12.422 49.63,10.719 C49.63,9.016 51.01,7.634 52.71,7.634 L54.26,7.634 C55.96,7.634 57.34,9.016 57.34,10.719 C57.34,12.422 55.96,13.803 54.26,13.803 Z M66.59,13.803 L65.05,13.803 C63.35,13.803 61.97,12.422 61.97,10.719 C61.97,9.016 63.35,7.634 65.05,7.634 L66.59,7.634 C68.3,7.634 69.68,9.016 69.68,10.719 C69.68,12.422 68.3,13.803 66.59,13.803 Z M78.93,13.803 L77.39,13.803 C75.69,13.803 74.3,12.422 74.3,10.719 C74.3,9.016 75.69,7.634 77.39,7.634 L78.93,7.634 C80.63,7.634 82.01,9.016 82.01,10.719 C82.01,12.422 80.63,13.803 78.93,13.803 Z M91.27,13.803 L89.73,13.803 C88.02,13.803 86.64,12.422 86.64,10.719 C86.64,9.016 88.02,7.634 89.73,7.634 L91.27,7.634 C92.97,7.634 94.35,9.016 94.35,10.719 C94.35,12.422 92.97,13.803 91.27,13.803 Z M103.6,13.803 L102.06,13.803 C100.36,13.803 98.98,12.422 98.98,10.719 C98.98,9.016 100.36,7.634 102.06,7.634 L103.6,7.634 C105.31,7.634 106.69,9.016 106.69,10.719 C106.69,12.422 105.31,13.803 103.6,13.803 Z M115.94,13.803 L114.4,13.803 C112.7,13.803 111.32,12.422 111.32,10.719 C111.32,9.016 112.7,7.634 114.4,7.634 L115.94,7.634 C117.65,7.634 119.03,9.016 119.03,10.719 C119.03,12.422 117.65,13.803 115.94,13.803 L115.94,13.803 Z",
    id: "Fill-693"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-694",
    points: "121.4 0 139.96 10.719 121.4 21.436 121.4 0"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0d8b061dbb8897678540ef229dfb3b5e.svg";
export { ForwardRef as ReactComponent };